<template>
  <div class="pt-4 md:pt-10 pb-14">
    <div class=" flex flex-col px-4 md:px-20 items-center">
      <div class="w-[100%] max-w-[76rem] py-10 flex flex-col md:flex-row gap-5 px-0 md:px-0 h-[40rem] md:h-[34rem]">
        
        <!-- LADO IZQUIERDO - Fijo -->
        <div class="flex flex-col w-full md:w-1/3 h-[62%] md:h-full">
          <CardServicio :data="cardData[0]" />
        </div>

        <!-- LADO DERECHO - CARRUSEL -->
        <div class="flex flex-col w-full md:w-2/3 h-[38%] md:h-full">
          <Carrusel 
            :data="cardData.slice(1)"
            :itemsPorPagina="itemsPorPagina"
            :ClaseSlide="ClaseSlide"
            :autoplay="true" 
            :autoplayInterval="3000" 
            :bucle="true"

            :habilitarBotonesNav="true"
            customBotonesNavClass="p-1 md:p-2 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
            customIconClass="text-current w-5 h-5" 
            customPrevPosition="left-0 -translate-x-4"
            customNextPosition="right-0 translate-x-4" 
           
            :motrarPuntos="false"
            customDotClass="w-2 h-2"
            customActiveDotClass="bg-ROJO_LEON w-6" 
            customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2">
            
            <!-- Slot para renderizar CardServicio -->
            <template #contenido="{ items }">
              <CardServicio v-for="(item, index) in items" :key="index" :data="item" />
            </template>
          </Carrusel>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import CardServicio from '~/components/Cards/CardServicio.vue'
import Carrusel from '~/components/Carruseles/Carrusel.vue'
import { NEGOCIOS } from "~/constants/negocios";

const cardData = [
  {
    title: 'Revisa tus',
    description: 'Diagnóstico, cambio de pastillas y discos con garantía León',
    descriptionBold: 'Tu seguridad comienza aquí',
    link: `/${NEGOCIOS.FRENOS}`,
    buttonText: 'Ir a Frenos',
    cont_padre: 'flex-col',
    tam_imagen_1: 'h-[42%] md:h-[46%] aspect-auto',
    cont_inferior: 'text-center items-center h-[58%] md:h-[50%] justify-between px-0 md:px-[4rem]',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    imagen_inferior: '/img/newhome/servicios/Frenos.svg',
    image: '/img/newhome/servicios/frenos.webp',
    backgroundimage: '/img/newhome/servicios/servicio-2.webp'
  },
  {
    title: '¿Tu auto no arranca? Nosotros te rescatamos.',
    description: 'Instalamos baterías nuevas en menos de 30 minutos con garantía total',
    descriptionBold: '',
    link: `/${NEGOCIOS.BATERIAS}`,
    buttonText: 'Ir a Baterías',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/baterias.webp',
    backgroundimage: '/img/newhome/servicios/servicio-4.webp'
  },
  {
    title: 'Soluciona vibraciones o ruidos al conduncir',
    description: 'Expertos en tren delantero para mantener tu dirección firme y segura',
    descriptionBold: '',
    link: `/${NEGOCIOS.TRENDELANTERO}`,
    buttonText: 'Ir a Tren delantero',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/Tren-Delantero.png',
    backgroundimage: '/img/newhome/servicios/Background/Tren-delantero-BG.webp'
  },
  {
    title: 'Protege tu motor con lubricantes premium.',
    description: 'Cambio express con productos certificados para máxima durabilidad',
    descriptionBold: '',
    link: `/${NEGOCIOS.ACEITES}`,
    buttonText: 'Ir a Cambio de aceite',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/aceite.webp',
    backgroundimage: '/img/newhome/servicios/servicio-3.webp'
  },
  {
    title: 'Cambia tus neumáticos en LEON.CL',
    description: 'Únicos con agendamiento online y pago en tienda',
    descriptionBold: '',
    link: '/neumaticos',
    buttonText: 'Ir a neumáticos',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/neumatico.png',
    backgroundimage: '/img/newhome/servicios/servicio-1.webp'
  },//SEGUNDO
  {
    title: 'Recupera estabilidad y confort al conducir',
    description: 'Alineamos tu vehículo con tecnología 3D láser para máxima precisión y seguridad',
    descriptionBold: '',
    link: `/${NEGOCIOS.ALINEACION}`,
    buttonText: 'Ir a Alineación',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/Alineacion.png',
    backgroundimage: '/img/newhome/servicios/Background/Alineacion-BG.png'
  },
    {
    title: 'Mejora la adherencia y el confort de marcha.',
    description: 'Cambiamos tus amortiguadores con tecnología de alto desempeño.',
    descriptionBold: '',
    link: `/${NEGOCIOS.AMORTIGUADORES}`,
    buttonText: 'Ir a Amortiguadores',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/amortiguadores.webp',
    backgroundimage: '/img/newhome/servicios/Background/amortiguadores-BG.png'
  },
    {
    title: 'Optimiza la geometría de tu vehículo',
    description: 'Servicio de geometría 3D para un desgaste parejo y mejor control',
    descriptionBold: '',
    link: `/${NEGOCIOS.GEOMETRIA}`,
    buttonText: 'Ir a Geometría',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/Geometria.png',
    backgroundimage: '/img/newhome/servicios/Background/Geometria-BG.png'
  },
    {
    title: 'Elimina vibraciones y extiende la vida de tus neumáticos',
    description: 'Balanceo computarizado de alta precisión para un manejo más suave',
    descriptionBold: '',
    link: `/${NEGOCIOS.BALANCEO}`,
    buttonText: 'Ir a Balanceo',
    cont_padre: 'flex-row-reverse',
    tam_imagen_1: 'w-[29%] md:w-[33%]',
    cont_inferior: 'w-full h-full justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
    image: '/img/newhome/servicios/Balanceo.png',
    backgroundimage: '/img/newhome/servicios/Background/Balanceo-BG.png'
  },//SEGUNDO
  {
  title: 'Devuelve la potencia y eficiencia a tu motor',
  description: 'Afinamiento electrónico con diagnóstico completo de performance',
  descriptionBold: '',
  link: `/${NEGOCIOS.AFINAMIENTO}`,
  buttonText: 'Ir a Afinamiento',
  cont_padre: 'flex-row-reverse',
  tam_imagen_1: 'w-[29%] md:w-[33%]',
  cont_inferior: 'w-full h-full justify-between',
  estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',
  image: '/img/newhome/servicios/Afinamiento.png',
  backgroundimage: '/img/newhome/servicios/Background/Afinamiento-BG.png'
},
  
]

// Items por página según pantalla
const itemsPorPagina = ref(1)

// Clase de  según pantalla
const ClaseSlide = ref('grid grid-cols-2 gap-5 h-full')

const handleResize = () => {
  if (window.innerWidth < 768) {
    itemsPorPagina.value = 1 // Móvil: 1 card por página
    ClaseSlide.value = 'flex flex-col gap-5 h-full'
  } else {
    itemsPorPagina.value = 4 // Desktop: 4 cards por página (2x2)
    ClaseSlide.value = 'grid grid-cols-2 grid-rows-2 gap-5 h-full'
  }
}

onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
/* Estilos adicionales si los necesitas */
</style>